import upload_video from "./upload_video.vue"


let uploadInstance
let instance
let init = false;
// options: upload_options 上传参数 sku_id, season_id
function upload(options = {}) {
  if (!init) {

    instance = new uploadInstance({
      data: options,
    })
    instance.$mount()
    let dom = instance.$el
    document.body.appendChild(dom)
  }
  instance.check_video()
  return instance
}

const install = async (app) => {
  let _vue = await (await import("vue")).default;
  uploadInstance = _vue.extend(upload_video)
  _vue.prototype.$upload_video = upload;
};

export default install



// WEBPACK FOOTER //
// ./src/components/v_upload_video/index.js